window.ActionPlanComplete = SplashScreen.extend({
    addListener: function() {
        this.$("a:first").each(function() {
            new Button({
                el: this,
                buttonClass: "action-button"
            });
        });
    }
});
